import { createFileRoute, useParams } from "@tanstack/react-router";
import { SidebarInset } from "@/components/ui/sidebar";
import { DashboardHeader } from "@/components/dashboard-header";
import { UserOvertimeDetailPage } from "@/components/user/overtime/UserOvertimeDetailPage";
import { requireFeature, requireSetting } from "@/lib/feature-gate";

export const Route = createFileRoute("/user/_layout/overtime_/$id")({
  beforeLoad: () => {
    requireFeature("attendance");
    requireSetting("overtime_approval_required");
  },
  component: UserOvertimeDetailRoute,
});

function UserOvertimeDetailRoute() {
  const { id } = useParams({ from: "/user/_layout/overtime_/$id" });
  return (
    <SidebarInset>
      <DashboardHeader current={"Overtime Detail"}
      />
      <div className="flex flex-col gap-4 p-6 pt-0">
        <UserOvertimeDetailPage approvalId={id} />
      </div>
    </SidebarInset>
  );
}
